import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import apiRequest from '../../functions/api';
import { Box } from "@mui/material";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import Page from '../shared/components/PageComponent';
import Layout from '../shared/components/LayoutComponent';
import { FullPageSpinner } from '../lib';
import InputBox from '../shared/components/InputBox';
import umlauteErsetzen from "../shared/functions/umlauteErsetzen";
import { useSessionStorage } from '../../utils/hooks';
import { LOCAL_STORAGE_KEY } from '../../constants/localStorage';

function ToDoDynamic() {
  const { t } = useTranslation();
  let { todokey } = useParams();
  const [questions, setQuestions] = useState([]);
  const [accessToken,] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const { hideMessage, showErrorMessage, showSuccessMessage } = useMessage();
  const navigate = useNavigate();
  const loadQuestions = () => {
    setIsLoading(true);
    const payload = {
      "statement": "DYNAMISCHE_FELDER_LESEN",
      "aufgabe": todokey,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'aufgaben', payload, headers, questionsCb);
  }
  useEffect(() => {
    loadQuestions();
    // eslint-disable-next-line
  }, [])
  const sendResponse = (results, files) => {
    setIsSending(true);
    setIsLoading(true)
    
    if (files.FILES!==undefined){
    const data = new FormData();
    data.append('file', files.FILES);
    const payload = {
      "statement": "DYNAMISCHE_FELDER_GESENDET",
      "aufgabe": todokey,
      "antworten": results,
      FileName: files.FILES ? umlauteErsetzen(files.FILES.name) : "",
    }
    data.append('payload', JSON.stringify(payload));
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'aufgaben', data, headers, resultCb, errorCb);
  }else{
    const payload = {
      "statement": "DYNAMISCHE_FELDER_GESENDET",
      "aufgabe": todokey,
      "antworten": results,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'aufgaben', payload, headers, resultCb, errorCb);
  }
  }
  const resultCb = (response) => {
    setIsSending(false);
    setIsLoading(false)
    if (response.status === 200) {
      showSuccessMessage(t("Ihre Änderungen wurden übernommen"));
      navigate(-1);
    } else {
      showErrorMessage(response.data.message);
    }
  }
  const errorCb = () => {
    setIsSending(false);
    showErrorMessage(t("Änderung konnte nicht gesendet werden. Bitte versuchen Sie es erneut."));
  }
  const questionsCb = (response) => {
    if (response.status === 200) {
      if (response.data.fragen) {
        setQuestions(response.data.fragen);
      } else {
        setQuestions([]);
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const cancel = () => {
    navigate(-1)
  }
  if (isLoading) {
    return <LoadingComponent />
  }
  return (
    <Page>
      <Layout>
        <Box p={2}>
          <InputBox
            onClose={cancel}
            handleResponse={sendResponse}
            fragen={questions}
            noDialog
          />
        </Box>
      </Layout>
      {isSending && <FullPageSpinner />}
    </Page>
  )
}
export default ToDoDynamic;
